export default __webpack_public_path__ + "static/media/formas_de_pago.d4d5d133.svg";